import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { HttpClient } from '@angular/common/http';
import { bmxurl, getAccess } from 'src/globals';
import { class_returndata } from 'src/types/class_returndata'; 
import { Router } from '@angular/router';
import { cClass } from 'src/types/class';
import {MessageService} from 'primeng/api';

import { users_returndata } from 'src/types/user_returndata';
import { emailtemplate_returndata } from 'src/types/emailtemplate_returndata';
import { cPackage } from 'src/types/package';
import { v4 } from 'uuid';
import { tag_returndata } from 'src/types/tag_returndata';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-marketingbirthdayedit',
  templateUrl: './marketingbirthdayedit.component.html',
  styleUrls: ['./marketingbirthdayedit.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MarketingbirthdayeditComponent {

  VenueID: string = localStorage.getItem("SmartVenueID")!;
  TaskType: any;
  httpResponse: any;
  id: string;
  pageReady: boolean = true;
  taskNameValid: boolean = true;
  taskDescValid: boolean = true;
  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  taskPurposes: any[];
  taskOptions: any[];
  taskTypevalue: any = { label: 'Remind', value: "REMIND", icon: "pi pi-bell" }
  EmailTemplates: any[] = [];
  selectedEmailTemplate: any;
  taskfrequency: any[];
  taskEmailTemplateValid: boolean = true;
  stateOptionsDiscount: any[];
  stateOptionsPackages: any[];

  packages: any[] = [];
  selectedPackages: any[] = [];
  allPackages: boolean = true;
  needSelectedPackages: boolean = false;

  tags: any[] = [];

  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private messageService: MessageService, private globalService: GlobalService) { 
      this.TaskType = {
        id: null,
        name: "",
        venueid: this.VenueID,
        disabled: false,
        desc: "",
        tasktype: "REMIND",
        noofdays: 1,
        emailtemplate: null,
        frequency: "NOREPEAT",
        packagelist: [],
        discounttype: "PERCENTAGE",
        discountamount: 0,
        campaignid: null,
        marketingtasktypeid: null,
        startdate: new Date(),
        enddate: new Date(),
        totalrevenue: 0,
        tags: []
      }

      this.taskfrequency = [{ label: 'No Repeat', value: "NOREPEAT" }, { label: 'Every Day', value: "DAILY" }, { label: 'Every other day', value: "EVERYOTHERDAY" }, { label: 'Weekly', value: "WEEKLY" }, { label: 'Every month', value: "MONTHLY"}, { label: 'Every 3 months', value: "EVERY3MONTHS"}];
      this.taskOptions = [{ label: 'Remind', value: "REMIND", icon: "pi pi-bell" }, { label: 'Collect', value: "COLLECT", icon: "pi pi-pound"  }, { label: 'Thank', value: "THANK", icon: "pi pi-heart"  }, { label: 'Feedback', value: "FEEDBACK", icon: "pi pi-thumbs-up"  }];
      this.stateOptionsDiscount = [{ label: 'Percentage', value: "PERCENTAGE" }, { label: 'Fixed Amount', value: "FIXED" }];
      this.stateOptionsPackages = [{ label: 'All Packages', value: true }, { label: 'Select Packages', value: false }];

      this.loadTags(false);
    }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);
    
    this.pageReady = false;
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("TASKS", user)){
          this.AccessAllowed = true;        

          this.id = this.route.snapshot.paramMap.get('id');
          if(this.id != "0")
          {
            this.pageReady = false;
            this.http.get(bmxurl + "MarketingTaskType/" + this.VenueID + "/" + this.id).subscribe(response => {
              this.httpResponse = (response as class_returndata)
              if (this.httpResponse.succeeded)
              {
                this.TaskType = {
                  id: (this.httpResponse.data as any).id,
                  name: (this.httpResponse.data as any).name,
                  venueid: (this.httpResponse.data as any).venueid,
                  disabled: (this.httpResponse.data as any).disabled,
                  desc: (this.httpResponse.data as any).desc,
                  tasktype: (this.httpResponse.data as any).tasktype,
                  noofdays: (this.httpResponse.data as any).noofdays,
                  emailtemplate: (this.httpResponse.data as any).emailtemplate,
                  frequency: (this.httpResponse.data as any).frequency,
                  packagelist: (this.httpResponse.data as any).packagelist,
                  discounttype: (this.httpResponse.data as any).discounttype,
                  discountamount: (this.httpResponse.data as any).discountamount,
                  campaignid: (this.httpResponse.data as any).campaignid,
                  marketingtasktypeid: (this.httpResponse.data as any).marketingtasktypeid,
                  startdate: (this.httpResponse.data as any).startdate,
                  enddate: (this.httpResponse.data as any).enddate,
                  totalrevenue: (this.httpResponse.data as any).totalrevenue,
                  tags: (this.httpResponse.data as any).tags
                };

                this.http.get(bmxurl + "/packagelist/" + this.VenueID + "/false").subscribe(response => {
                  this.httpResponse = response
                  if(this.httpResponse.succeeded)
                  {
                    this.packages = (response as class_returndata).data;

                    this.TaskType.packagelist.forEach(element => {
                      let newpack = this.packages.filter(obj => obj.packageId == element);
                      if(newpack != null && newpack.length > 0)
                      {
                        let existingpack = this.selectedPackages.filter(obj => obj.packageId == element);

                        if(existingpack.length == 0)
                        {
                          this.selectedPackages.push(newpack[0]);
                        }
                      }
                    });

                    this.selectedPackages.forEach(element => {
                      this.packages = this.packages.filter(obj => obj.id !== element.id);
                    });

                    if(this.selectedPackages.length == 0)
                    {
                      this.allPackages = true;
                    }
                    else
                    {
                      this.allPackages = false;
                    }
          
                    this.pageReady = true;   
                  }
                  else
                  {
                    this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Packages'});
                    this.pageReady = false;
                  }
                }, error => {
                  this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Packages, error:' + error.messages[0]});
                  this.pageReady = false;
                });
           
              }
              else
              {
                this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Task Types'});
                this.pageReady = false;
              }
            }, error => {
              this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Task Types, error:' + error.messages[0]});
              this.pageReady = false;
            });
          }
          else
          {
            this.http.get(bmxurl + "/packagelist/" + this.VenueID + "/false").subscribe(response => {
              this.httpResponse = response
              if(this.httpResponse.succeeded)
              {
                this.packages = (response as class_returndata).data;
      
                this.pageReady = true;   
              }
              else
              {
                this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Packages'});
                this.pageReady = false;
              }
            }, error => {
              this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Packages, error:' + error.messages[0]});
              this.pageReady = false;
            });
          }
        }

        this.CompletedLoading = true;
        this.pageReady = true;
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });

    this.http.get(bmxurl + "/EmailTemplateList/" + this.VenueID + "/false").subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.EmailTemplates = (response as emailtemplate_returndata).data;
      }
      else
      {
        this.messageService.add({severity:'warn', summary:'Response Message', detail: this.httpResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Email Templates, error: ' + error.messages});
    });

  }

  loadTags(showdisabled: boolean) {
    this.http.get(bmxurl + "TagList/" + this.VenueID + "/" + showdisabled).subscribe(response => {
      this.tags = (response as tag_returndata).data;
    }, error => {
    });
  }
  
  AddToList(product){
    if(this.packages == null)
    {
      let newId = v4();
      let newpeId = v4();

      this.selectedPackages = [];
      let newPackage: cPackage = {
        id: product.id,
        packageId: product.packageId,
        name: product.name,
        eventid: product.eventid,
        description: product.description,
        imageurl: product.imageurl,
        message: product.message,
        disabled: product.disabled,
        venueID: this.VenueID,
        resources: product.resources,
        startTimes: product.startTimes,
        admissions: product.admissions,
        packageLength: product.packageLength,
        questionnaire: product.questionnaire,
        visibility: product.visibility,
        min:product.min,
        max:product.max,
        tags: product.tags,
        startDate: product.startDate,
        endDate: product.endDate,
        colour: product.colour,
        packageRule: product.packageRule,
        packageRestriction: product.packageRestriction,
        extras: product.extras,
        publicDepositPolicy: product.publicDepositPolicy,
        venueDepositPolicy: product.venueDepositPolicy,
        additionalresources: product.additionalresources,
        confirmation: product.confirmation,
        warning: product.warning,
        originatingid: product.originatingid,
        bookingscannotbemadewithinxminutes: product.bookingscannotbemadewithinxminutes,
        bookingscannotbemadeafterxminutes: product.bookingscannotbemadeafterxminutes,
        cannotmakebookingstoday: product.cannotmakebookingstoday,
        discounttype: product.discounttype,
        discountamount: product.discountamount,
        discountcode: product.discountcode,
        discountstart: product.discountstart,
        discountend: product.discountend,
        earlybirddiscount: product.earlybirddiscount,
        discountrangetype: product.discountrangetype,
        discountdaysbefore: product.discountdaysbefore,
        imageguid: product.imageguid,
        bookingtimeout: product.bookingtimeout,
        maxcalendarmonths: product.maxcalendarmonths,
        packageupgrades: product.packageupgrades,
        packageabupgrades: product.packageabupgrades,
        waiverrequired: product.waiverrequired,
        ispartypackage: product.ispartypackage,
        bookingfeeid: product.bookingfeeid,
        portaltemplateid: product.portaltemplateid,
        cannotbepaidwithvoucher: product.cannotbepaidwithvoucher
      }

      this.selectedPackages.push(newPackage);
    }
    else{
      let newId = v4();
      let newpeId = v4();

      let newPackage: cPackage = {
        id: product.id,
        packageId: product.packageId,
        name: product.name,
        eventid: product.eventid,
        description: product.description,
        imageurl: product.imageurl,
        message: product.message,
        disabled: product.disabled,
        venueID: this.VenueID,
        resources: product.resources,
        startTimes: product.startTimes,
        admissions: product.admissions,
        packageLength: product.packageLength,
        questionnaire: product.questionnaire,
        visibility: product.visibility,
        min:product.min,
        max:product.max,
        tags: product.tags,
        startDate: product.startDate,
        endDate: product.endDate,
        colour: product.colour,
        packageRule: product.packageRule,
        packageRestriction: product.packageRestriction,
        extras: product.extras,
        publicDepositPolicy: product.publicDepositPolicy,
        venueDepositPolicy: product.venueDepositPolicy,
        additionalresources: product.additionalresources,
        confirmation: product.confirmation,
        warning: product.warning,
        originatingid: product.originatingid,
        bookingscannotbemadewithinxminutes: product.bookingscannotbemadewithinxminutes,
        bookingscannotbemadeafterxminutes: product.bookingscannotbemadeafterxminutes,
        cannotmakebookingstoday: product.cannotmakebookingstoday,
        discounttype: product.discounttype,
        discountamount: product.discountamount,
        discountcode: product.discountcode,
        discountstart: product.discountstart,
        discountend: product.discountend,
        earlybirddiscount: product.earlybirddiscount,
        discountrangetype: product.discountrangetype,
        discountdaysbefore: product.discountdaysbefore,
        imageguid: product.imageguid,
        bookingtimeout: product.bookingtimeout,
        maxcalendarmonths: product.maxcalendarmonths,
        packageupgrades: product.packageupgrades,
        packageabupgrades: product.packageabupgrades,
        waiverrequired: product.waiverrequired,
        ispartypackage: product.ispartypackage,
        bookingfeeid: product.bookingfeeid,
        portaltemplateid: product.portaltemplateid,
        cannotbepaidwithvoucher: product.cannotbepaidwithvoucher
      }

      this.selectedPackages.push(newPackage);
    }

    this.packages = this.packages.filter(obj => obj.id !== product.id);
  }

  RemoveFromList(product){
    this.selectedPackages = this.selectedPackages.filter(obj => obj.id !== product.id);

    this.packages.push(product);

    var sortedArray:any[] = this.packages.sort((n1,n2) => {
      if (n1.name > n2.name) {
          return 1;
      }
  
      if (n1.name < n2.name) {
          return -1;
      }
    });

    this.packages = sortedArray;
  }

  updateData()
  {
    if(this.allPackages)
    {
      this.selectedPackages = [];
    }

    if(this.allPackages == false && this.packages.length == 0)
    {
      this.needSelectedPackages = true;
    }
    else
    {
      this.needSelectedPackages = false;
    }

    if(!this.needSelectedPackages)
    {
      if (this.DoValidCheck())
      {
        this.TaskType.packagelist = [];

        this.selectedPackages.forEach(element => {
          this.TaskType.packagelist.push(element.packageId);
        });

        if(this.id == "0")
        {
          this.http.post<cClass>(bmxurl + "/MarketingTaskType", this.TaskType).subscribe(response => {
            this.httpResponse = response
              if(this.httpResponse.succeeded)
              {
                this.messageService.add({severity:'success', summary:'Saved', detail:'Marketing Task Type successfully created'});
                this.router.navigateByUrl("/marketingbirthday");
              }
              }, error => {
                this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages});
            })
        }
        else
        {
          this.TaskType.disabled = false;
          
          this.http.put<cClass>(bmxurl + "/MarketingTaskType", this.TaskType).subscribe(response => {
          this.httpResponse = response
            if(this.httpResponse.succeeded)
            {
              this.messageService.add({severity:'success', summary:'Saved', detail:'Marketing Task Type successfully updated'});
              this.router.navigateByUrl("/marketingbirthday");
            }
            }, error => {
              this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages});
          })
        }
      }
    }
  }

  DoValidCheck()
  {
    let AllValid = true;

    if(this.TaskType.name == null || this.TaskType.name == "")
    {
      AllValid = false;
      this.taskNameValid = false;
    }
    else
    {
      this.taskNameValid = true;
    }

    if(this.TaskType.emailtemplate == null )
    {
      AllValid = false;
      this.taskEmailTemplateValid = false;
    }
    else
    {
      this.taskEmailTemplateValid = true;
    }

    return AllValid;
  }

  returnToList()
  {
    this.router.navigateByUrl("/tasktypelist");
  }
}
